<template>

  <el-form :model="form" :rules="rules" ref="form" v-loading="isLoading">

    <p>Informe o endereço completo, conforme confsta no IPTU do imóvel.</p>
    <br>

    <el-form-item>

      <el-col :span="8">
        
        <el-form-item label="Cep" prop="cep">
          <div class="el-input">
            <input type="text" v-model="form.cep" placeholder="Cep" v-mask="'99999-999'"class="el-input__inner" autofocus />
          </div>
        </el-form-item>

      </el-col>

      <el-col :offset="1" :span="15">

        <el-form-item label="Endereço" prop="logradouro">
          <el-input v-model="form.logradouro" placeholder="Endereço" :disabled="isDisabled"></el-input>
        </el-form-item>

      </el-col>

    </el-form-item>

    <el-form-item>

      <el-col :span="8">

        <el-form-item label="Número" prop="numero">
          <el-input v-model="form.numero" placeholder="Número" ref="numero"></el-input>
        </el-form-item>

      </el-col>

      <el-col :offset="1" :span="7">

        <el-form-item label="Complemento" prop="complemento">
          <el-input v-model="form.complemento" placeholder="Complemento"></el-input>
        </el-form-item>

      </el-col>

      <el-col :offset="1" :span="7">

        <el-form-item label="Bairro" prop="bairro">
          <el-input v-model="form.bairro" placeholder="Bairro" :disabled="isDisabled"></el-input>
        </el-form-item>

      </el-col>

    </el-form-item>

    <el-form-item>

      <el-col :span="12">

        <el-form-item label="Cidade" prop="cidade">
          <el-input v-model="form.cidade" placeholder="Cidade" :disabled="isDisabled"></el-input>
        </el-form-item>

      </el-col>

      <el-col :offset="1" :span="11">

        <el-form-item label="Estado" prop="estado">
          <el-input v-model="form.estado" placeholder="Estado" :readonly="isDisabled"></el-input>
        </el-form-item>

      </el-col>

    </el-form-item>

  </el-form>

</template>

<script>
import AwesomeMask from 'awesome-mask'

export default {
  props: ['form'],

  directives: {
    'mask': AwesomeMask
  },

  data () {
    return {
      isLoading: false,
      isDisabled: false,
      rules: {
        cep: [
          { required: true, message: 'O CEP é obrigatório', trigger: 'blur' },
          { type: 'string', pattern: /[0-9]{5}-[0-9]{3}/, message: 'Você deve digitar um CEP no formato correto: Ex. 99999-999', trigger: 'blur' }
        ],
        logradouro: [
          { required: true, message: 'O endereço é obrigatório', trigger: 'blur' }
        ],
        numero: [
          { required: true, message: 'O número é obrigatório', trigger: 'blur' }
        ],
        bairro: [
          { required: true, message: 'O bairro é obrigatório', trigger: 'blur' }
        ],
        cidade: [
          { required: true, message: 'A cidade é obrigatória', trigger: 'blur' }
        ],
        estado: [
          { required: true, message: 'O estado é obrigatório', trigger: 'blur' }
        ]
      }
    }
  },

  watch: {
    'form.cep' (value, oldValue) {
      if (value.length === 9) {
        this.searchAddress()
      }
    }
  },

  methods: {
    searchAddress () {
      const cep = this.form.cep.replace(/\D+/g, '')

      if (cep.length === 8) {
        this.isLoading = true

        this.$http.get('https://api.postmon.com.br/v1/cep/' + cep)
          .then((response) => {
            this.isLoading = false

            if (response.ok) {
              this.isDisabled = true

              this.form.numero = ''
              this.form.logradouro = response.data.logradouro
              this.form.bairro = response.data.bairro
              this.form.cidade = response.data.cidade
              this.form.estado = response.data.estado

              this.$refs.numero.$refs.input.focus()
            }
          })
          .catch((response) => {
            this.isLoading = false

            this.$message({ showClose: true, type: 'error', message: response.statusText })

            this.isDisabled = false

            this.$refs.form.resetFields()
          })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// EnderecoEmpresa.vue?01a924fb